import Firebase from '../../../lib/Firebase';

export default {
  saveCityInformation(cityId, name, manager, configs) {
    const cityObj = {
      name,
      manager,
      configs
    };

    return Firebase.firestore()
      .collection('cities')
      .doc(cityId)
      .update(cityObj);
  }
};



// WEBPACK FOOTER //
// ./src/pages/cities/Information/service.js